module.exports = __webpack_public_path__ + "img/ug351.64187400.png";